import React, { Component } from "react";
import { terms } from "../helper/lists.js";
import "./../pages/Calculators.css";
import { Row } from "react-bootstrap";

interface IProps {
  label?: any;
  selectedterm?: number;
  classes?: string;
  onChange(v: any): void;
  onBlur?(): void;
}

export class TermSelect extends Component<IProps, any> {
  render() {
    return (
      <div className="calc-grid justify-left">
        <Row>
          {this.props.label && (
            <label className="calculator-labels" htmlFor="term">
              {this.props.label}
            </label>
          )}
        </Row>
        {/* <i className='fa fa-calendar s30' style={{float: 'left', position: 'absolute', marginTop: 30, marginLeft: 10}} /> */}
        <select
          name="term"
          id="term"
          aria-required="true"
          aria-invalid="false"
          className={`${this.props.classes ?? ""} select-input`}
          onChange={this.props.onChange}
          onBlur={() => {
            if (this.props.onBlur) this.props.onBlur();
          }}
          value={this.props.selectedterm}
        >
          {terms.map((t) => {
            return (
              <option
                key={"currentlypaying-term-" + t.value}
                value={t.value}
                selected={
                  t.name ===
                  (this.props.selectedterm
                    ? this.props.selectedterm + " years"
                    : "25 years")
                }
              >
                {t.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}
